import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'
import { SiteConfig } from '@navent-jobs/config'
import Text from '@navent-jobs/ui-kit/components/text'

// mixins
import { InfoCol, DataRow, DataIcon } from '../../mixins'
import { DataInfo, DataInfoContainer } from './mixins'

// constants
import { SITE_ID } from '../../../../constants'

interface ComponentProps {
  avisoCrossPais: number
  localizacion: string
  modalidadTrabajo?: string
  tipoTrabajo?: string
  mobileFormat?: boolean
  aptoDiscapacitado?: boolean
  isDesktop?: boolean
}

const Component = ({
  avisoCrossPais,
  localizacion,
  modalidadTrabajo,
  tipoTrabajo,
  mobileFormat,
  aptoDiscapacitado,
  isDesktop,
}: ComponentProps) => {
  const { colors } = useContext<{ colors }>(ThemeContext)
  const siteConfig = SiteConfig[SITE_ID]
  const ID_PAIS = siteConfig && siteConfig.pais && siteConfig.pais.id
  const isMobileFormat = !isDesktop || mobileFormat
  const iconSize = isMobileFormat ? 16 : 20

  return (
    <>
      <DataInfoContainer mobileFormat={mobileFormat}>
        <InfoCol mobileFormat={mobileFormat}>
          <DataRow mobileFormat={mobileFormat}>
            {avisoCrossPais !== null && avisoCrossPais !== ID_PAIS ? (
              <DataIcon name="icon-light-globe" size={iconSize} color={colors.grey84} />
            ) : (
              <DataIcon name="icon-light-location-pin" size={iconSize} color={colors.grey84} />
            )}
            <DataInfo>
              <Text size="sm" as="h3">
                {localizacion}
              </Text>
            </DataInfo>
          </DataRow>

          {(modalidadTrabajo || tipoTrabajo) && (
            <DataRow mobileFormat={mobileFormat}>
              <DataIcon name="icon-light-office" size={iconSize} color={colors.grey84} />
              <DataInfo>
                <Text size="sm" as="h3">
                  {modalidadTrabajo || tipoTrabajo}
                </Text>
              </DataInfo>
            </DataRow>
          )}

          {isMobileFormat && aptoDiscapacitado && (
            <DataRow mobileFormat={mobileFormat}>
              <DataIcon name="icon-light-discapacity" size={iconSize} color={colors.grey84} />
              <Text size="sm" variant="gray84" as="h3">
                Apto discapacidad
              </Text>
            </DataRow>
          )}
        </InfoCol>
      </DataInfoContainer>
    </>
  )
}

export default Component
